import React from 'react'
import { Badge } from 'antd'

import type { LntBadgeProps } from './types'

export const LntBadge: React.FC<LntBadgeProps> = props => {
  const { children, ...restProps } = props

  return <Badge { ...restProps }>{ children }</Badge>
}
